import DownloadIcon from "@/components/icons/DownloadIcon";
import Spinner from "@/components/spinner/Spinner";
import {
  useDownloadCourseCertificateAttachment,
  useDownloadTeachingAttachment,
} from "@/hooks/cle-hooks";
import { showCleApiErrorToast } from "@/lib/showCleApiErrorToast";
import { useToaster } from "rsuite";

import type { SupplementaryDocumentKind } from "./types";

interface SupplementaryDocumentDownloadButtonProps {
  attachmentId: string;
  evidenceId: string;
  kind: SupplementaryDocumentKind;
  userId: string;
}

/** Hent-knappen til dialogens fodlinje, hvor modalens egne handlinger hører til. */
export const SupplementaryDocumentDownloadButton = ({
  attachmentId,
  evidenceId,
  kind,
  userId,
}: SupplementaryDocumentDownloadButtonProps) => {
  const toaster = useToaster();
  // Begge mutationer findes altid, saa hook-raekkefoelgen er den samme; kun
  // den, der passer til beviset, bliver kaldt.
  const certificateDownload = useDownloadCourseCertificateAttachment();
  const teachingDownload = useDownloadTeachingAttachment();
  const isPending = certificateDownload.isPending || teachingDownload.isPending;
  const onError = (err: Error) => showCleApiErrorToast(toaster, err);

  return (
    <button
      type="button"
      className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-2 ms-auto"
      disabled={isPending}
      onClick={() =>
        kind === "undervisning"
          ? teachingDownload.mutate(
              { userId, teachingId: evidenceId, attachmentId },
              { onError },
            )
          : certificateDownload.mutate(
              { userId, id: evidenceId, attachmentId },
              { onError },
            )
      }
    >
      {isPending ? <Spinner size={14} /> : <DownloadIcon height={16} />}
      Hent
    </button>
  );
};
